import { cleanExpenseDataForSubmit } from 'components/pages/Expenses/Form/utils';
import { useMemo } from 'react';
import { ConversationMetadata } from 'types/ai.types';
import { IExpenseFormValuesV2, PartialIExpenseV2 } from 'types/expenses.types';
import { dateNumberToString } from 'utils/helpers';
import { getVATAmountFromAmountInclVAT } from 'utils/math';
import { useSetAiMetadata } from '.';

export const mapExpenseMetadata = (
  expense: PartialIExpenseV2,
): ConversationMetadata => ({
  documentId: expense?._id,
  documentType: 'expense',
  data: {
    supplier: expense?.supplier,
    filename: expense?.file?.path?.split('/').pop(),
    date: expense?.expenseDateNumber
      ? dateNumberToString(expense.expenseDateNumber)
      : undefined,
    period: expense?.period,
    amount: expense?.items?.reduce(
      (acc, i) => acc + (i.currencyAmount || 0),
      0,
    ),
    items: expense?.items?.map((i) => ({
      name: i.name,
      amount: i.currencyAmount,
      VATAmount: getVATAmountFromAmountInclVAT(
        i.currencyAmount || 0,
        i.VATRate || 0,
      ),
      category: i.category?.title,
      professionalPercentage: (i.professionalPart || 0) * 100,
    })),
  },
});

export const useExpenseAiMetadata = (expense?: IExpenseFormValuesV2) => {
  const _expense = useMemo(
    () =>
      expense && {
        _id: expense._id,
        ...cleanExpenseDataForSubmit(expense),
      },
    [expense],
  );
  return useSetAiMetadata(_expense, 'expense', mapExpenseMetadata);
};
